import { render, staticRenderFns } from "./prospect_stats_strip.vue?vue&type=template&id=2bce60ec&"
import script from "./prospect_stats_strip.vue?vue&type=script&lang=js&"
export * from "./prospect_stats_strip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports